export const ACTUALIZAR_LIST_ATRIBUTOS_FICHA = "ACTUALIZAR_LIST_ATRIBUTOS_FICHA";
export const CALCULAR_MANTENIMIENTOS_ATRIBUTOS_FICHAS = "CALCULAR_MANTENIMIENTOS_ATRIBUTOS_FICHAS"
export const AGREGAR_ATRIBUTOS_FICHA = "AGREGAR_ATRIBUTOS_FICHA";  
export const MODIFICAR_ATRIBUTOS_FICHA = "MODIFICAR_ATRIBUTOS_FICHA";